import { buildWriterLinkButtonHtml } from './writerFormat';
import { getWriterEditorHtml } from './writerEditorApi';

export const WRITER_FORMAT_ACTIONS = [
  { id: 'h1', label: 'H1' },
  { id: 'h2', label: 'H2' },
  { id: 'p', label: 'Body' },
  { id: 'bold', label: 'B', title: 'Bold (⌘B)' },
  { id: 'italic', label: 'I', title: 'Italic (⌘I)' },
  { id: 'underline', label: 'U', title: 'Underline (⌘U)' },
  { id: 'strike', label: 'S', title: 'Strikethrough (⌘⇧S)' },
  { id: 'bullet', label: 'List' },
  { id: 'alignLeft', label: 'Left' },
  { id: 'alignCenter', label: 'Center' },
  { id: 'alignRight', label: 'Right' },
];

function normalizeUrl(raw) {
  const value = String(raw || '').trim();
  if (!value) return '';
  if (/^(https?:\/\/|mailto:|tel:)/i.test(value)) return value;
  return `https://${value}`;
}

function emitHtml(editor, onChange) {
  onChange?.(getWriterEditorHtml(editor));
}

export function runWriterFormatCommand(editor, action, onChange) {
  if (!editor) return;
  const chain = editor.chain().focus();

  switch (action.id) {
    case 'h1':
      chain.toggleHeading({ level: 1 });
      break;
    case 'h2':
      chain.toggleHeading({ level: 2 });
      break;
    case 'p':
      chain.setParagraph();
      break;
    case 'bold':
      chain.toggleBold();
      break;
    case 'italic':
      chain.toggleItalic();
      break;
    case 'underline':
      chain.toggleUnderline();
      break;
    case 'strike':
      chain.toggleStrike();
      break;
    case 'bullet':
      chain.toggleBulletList();
      break;
    case 'alignLeft':
      chain.setTextAlign('left');
      break;
    case 'alignCenter':
      chain.setTextAlign('center');
      break;
    case 'alignRight':
      chain.setTextAlign('right');
      break;
    default:
      return;
  }

  chain.run();
  emitHtml(editor, onChange);
}

export function insertWriterHtml(editor, html, onChange) {
  if (!editor) return;
  editor.chain().focus().insertContent(String(html || '')).run();
  emitHtml(editor, onChange);
}

export function insertWriterHyperlink(editor, url, label, onChange) {
  const href = normalizeUrl(url);
  if (!href || !editor) return;

  const { from, to } = editor.state.selection;
  const selectedText = editor.state.doc.textBetween(from, to, ' ').trim();
  const text = String(label || selectedText || href).trim();

  if (selectedText) {
    editor.chain().focus().extendMarkRange('link').setLink({ href }).run();
  } else {
    editor
      .chain()
      .focus()
      .insertContent(
        `<a href="${escapeAttr(href)}" target="_blank" rel="noopener noreferrer">${escapeHtml(text)}</a>`
      )
      .run();
  }
  emitHtml(editor, onChange);
}

export function insertWriterLinkButton(editor, url, label, onChange) {
  const href = normalizeUrl(url);
  const text = String(label || url || 'Open link').trim();
  if (!href || !text || !editor) return;
  insertWriterHtml(editor, buildWriterLinkButtonHtml(href, text), onChange);
}

function escapeHtml(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

function escapeAttr(value) {
  return String(value || '').replace(/"/g, '&quot;');
}
